import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import { toJS } from 'mobx'
import { Formik, Form, Field } from 'formik'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import pick from 'lodash/pick'

import { expertApi, fileApi } from '@atheneum/api'

import { Dropdown } from '@components/Form/Autocomplete'
import { Autocomplete } from '@components/Autocomplete'
import Input from '@components/Form/Input'
import Checkbox from '@components/Form/Checkbox'
import Tooltip from '@components/Tooltip'
import { FlexRow, FlexItem } from '@components/Flex'
import ACL from '@components/ACL/ACL'
import FullProfileIcon from '@components/Icon/FullProfile'
import DeleteIcon from '@components/Icon/Delete'
import PdfIcon from '@components/Icon/Pdf'
import Pagination from '@components/Pagination/Pagination'
import Spinner from '@components/spinner'
import EPLAutosave from './EPLAutosave'
import TeamInfoTooltip from '@components/TeamInfoTooltip'
import Attachment, { confirmDelete } from '@components/Attachment'
import MaUTable from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { formatDate, tokenStorage } from '@atheneum/api/dist/lib'

class EPLExpand extends Component {
  static propTypes = {
    eplModel: PropTypes.object,
    staticData: PropTypes.object,
    projectStore: PropTypes.object,
    epl: PropTypes.object,
    segmentStore: PropTypes.object,
    eplStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    growlStore: PropTypes.object
  }
  constructor(props) {
    super(props)

    extendObservable(this, {
      honorariumTabActive: false,
      projects: {
        rows: [],
        count: 0
      },
      page: 1,
      loading: false
    })
  }

  get(page) {
    this.loading = true

    if (!this.props.epl.expertId || !page) return null

    const limit = 5
    const offset = (page - 1) * limit

    return expertApi
      .getExpertHonorariumHistory(
        this.props.epl.expertId,
        limit,
        offset
      )
      .then(({ rows, count }) => {
        this.projects.rows = rows
        this.projects.count = count
        this.loading = false
      })
      .catch(err => {
        this.props.growlStore.showError(err)
        this.loading = false
      })
  }

  changePage = page => {
    this.page = page
    this.get(page)
  }

  showHonorariumTab = async show => {
    if (show) await this.get(this.page)
    this.honorariumTabActive = show
  }

  showProjectDetails = (e, id) => {
    e.stopPropagation()
    this.props.sidebarStore.openSidebar({
      template: 'project',
      id: id
    })
  }

  renderCurrency = (honorarium, currencyId, array) => {
    if (!honorarium || !currencyId || !array) return ''
    const currency = this.props.staticData.getDataFromArray(currencyId, array)
    return honorarium + ' ' + currency + '/hr'
  }

  handleFreeChange = (free, form) => {
    if (free) {
      form.setFieldValue('honorariumCurrencyId', null, false)
      form.setFieldValue('honorarium', 0, false)
    }
    form.setFieldValue('free', free, false)
  }

  renderRecommendedHonorarium() {
    const h =
      this.props.eplModel.recommendedHonorarium
    const hc =
      this.props.eplModel.recommendedHonorariumCurrencyId

    return (
      h && hc &&
      !this.props.eplModel.epl.free && (
        <div style={{ marginTop: 8, paddingLeft: 120 }}>
          Computed maximum honorarium: {this.props.staticData.names.currencies[hc]} {h}
          <span style={{ color: '#FF5858' }}> BETA</span>
        </div>
      )
    )
  }

  renderMargin(margin) {
    if (!margin && margin !== 0) {
      return <span />
    } else {
      const marginOk = margin >= 0.76
      return (
        <span>
          Projected margin:{' '}
          <span className={marginOk ? 'green-text' : 'red-text'}>
            {(margin * 100).toFixed(2)}%
          </span>{' '}
          <span>(Target 76%)</span>
        </span>
      )
    }
  }

  handleInputOnBlur = async (inputValue, name, form) => {
    const { epl, eplModel } = this.props
    eplModel.eplValuesBeingUpdated = true

    let values = form.values
    if (name === 'credits' && !Number.isNaN(Number(form.values.credits))) {
      const contract = this.props.projectStore.applicableContracts[0]
      values = {
        ...form.values,
        fee:inputValue * contract.creditValue,
        feeCurrencyId:contract.currencyId
      }
      form.setValues(values,false)
    } else if (['fee', 'feeCurrencyId'].includes(name)) {
      form.setFieldValue('credits', null, false)
      values = {...form.values, credits:null}
    }

    if (Number(inputValue) !== epl[`${name}`]) {
      eplModel.autosave(epl.id, values)
    }
    if (!inputValue) {
      form.setFieldValue(name, epl[`${name}`], false)
    }
  }

  handleDeliveredByChange = employee => {
    if (!employee) return
    const { epl, eplModel } = this.props
    eplModel.changeDeliveredBy(epl.id, employee.id)
  }

  isCreditBasedContract = this.props.projectStore.isCreditBasedContract

  renderExportButton = () => {
    const token = tokenStorage.get()
    return (
      <a
        href={
          '/api/expert-project-link/' +
          this.props.epl.id +
          '/export?token=' +
          token
        }
        download
        target='_blank'
        rel="noopener noreferrer"
      >
        <div className='icon-label'>
          <PdfIcon />
          <span>PDF export</span>
        </div>
      </a>
    )
  }

  handleDeleteEpl = () => {
    const { epl, eplStore } = this.props
    eplStore.delete(epl)
  }

  render() {
    const { epl, eplModel, staticData, segmentStore } = this.props
    const { collapse, expanded, expandComplete, details } = eplModel
    if (!epl || !expanded || !details) return null

    const expertId = epl.expert.id
    const expertProfileLink = `/expert/${expertId}`

    let boxClass = 'single__content__expanded'
    boxClass += collapse ? ' single__content__expanded--collapse' : ''
    const boxOverflow = expandComplete ? 'visible' : 'hidden'
    const margin = eplModel.projectedMargin || epl.projectedMargin
    const { honorariumTabActive, loading } = this
    const paidProjects = this.projects.rows.filter(r => r.expertProjectLink)
    const mckinseyProject = this.props.projectStore.capiDetails

    return (
      <div className='epl-expand-wrapper' data-cy={epl.id}>
        <div className={`${boxClass} ${boxOverflow}`}>
          <Formik
            initialValues={initializeForm(epl)}
            render={form => (
              <div className='block'>
                <div style={{ display: 'flex' }}>
                  <div
                    className='epl-expand-wrapper__actions'
                    style={{ flexShrink: 0 }}
                  >
                    <div style={{ display: 'flex' }}>
                      <div>
                        <Form>
                          {epl.eplStatusCommentId && (
                            <Field
                              labelClass='actions__single__label'
                              groupClass='actions__single'
                              wrapperClass='actions__single__value'
                              name='eplStatusCommentId'
                              label='Comment'
                              itemToString={item => item && item.name}
                              options={staticData.eplStatusComments}
                              component={Dropdown}
                            />
                          )}
                          <Field
                            labelClass='actions__single__label'
                            groupClass='actions__single'
                            wrapperClass='actions__single__value'
                            name='segmentId'
                            label='Segment'
                            itemToString={item => item && item.name}
                            options={segmentStore.segments}
                            component={Dropdown}
                            disabled={mckinseyProject ? true : false}
                          />
                          <RenderEplRow
                            label={
                              <span>
                                Honorarium <strong>*</strong>
                              </span>
                            }
                            onClick={() => this.showHonorariumTab(true)}
                          >
                            <FlexRow itemSpacing='md'>
                              <FlexItem>
                                <Field
                                  name='honorariumCurrencyId'
                                  placeholder='Currency'
                                  itemToString={item => item && item.name}
                                  options={staticData.getHonorariumCurrencyOptions()}
                                  disabled={form.values.free}
                                  component={Dropdown}
                                  data-cy='honorarium-currency-dropdown'
                                />
                              </FlexItem>
                              <FlexItem>
                                <Field
                                  name='honorarium'
                                  placeholder='Amount'
                                  onBlur={e =>
                                    this.handleInputOnBlur(
                                      e.target.value,
                                      'honorarium',
                                      form
                                    )
                                  }
                                  disabled={form.values.free}
                                  component={Input}
                                  data-cy='honorarium-amount'
                                />
                              </FlexItem>
                              <FlexItem>
                                <Field
                                  name='free'
                                  label='Free'
                                  tooltip={
                                    'Check the box for ‘Free’ if Payment to Expert is not required.'
                                  }
                                  onChange={e =>
                                    this.handleFreeChange(
                                      e.target.checked,
                                      form
                                    )
                                  }
                                  component={Checkbox}
                                />
                              </FlexItem>
                            </FlexRow>
                          </RenderEplRow>
                          <RenderEplRow
                            label={
                              <span>
                                Fee <strong>*</strong> / Credits
                              </span>
                            }
                          >
                            <FlexRow itemSpacing='md'>
                              <FlexItem>
                                <Field
                                  name='feeCurrencyId'
                                  disabled={this.isCreditBasedContract()}
                                  title={
                                    this.isCreditBasedContract() &&
                                    "You can't edit fee since applicable contract is credit based"
                                  }
                                  placeholder='Currency'
                                  itemToString={item => item && item.name}
                                  options={staticData.currencies}
                                  component={Dropdown}
                                  data-cy='fee-currency-dropdown'
                                />
                              </FlexItem>
                              <FlexItem>
                                <Field
                                  name='fee'
                                  placeholder='Amount'
                                  disabled={this.isCreditBasedContract()}
                                  title={
                                    this.isCreditBasedContract() &&
                                    "You can't edit fee since applicable contract is credit based"
                                  }
                                  onBlur={e =>
                                    this.handleInputOnBlur(
                                      e.target.value,
                                      'fee',
                                      form
                                    )
                                  }
                                  component={Input}
                                  data-cy='fee-amount'
                                />
                              </FlexItem>
                              <FlexItem>
                                <FlexRow>
                                  <Field
                                    name='credits'
                                    disabled={!this.isCreditBasedContract()}
                                    title={
                                      !this.isCreditBasedContract() &&
                                      "You can't edit credits since applicable contract is not credit based"
                                    }
                                    placeholder='Credits'
                                    onBlur={e =>
                                      this.handleInputOnBlur(
                                        e.target.value,
                                        'credits',
                                        form
                                      )
                                    }
                                    component={Input}
                                  />
                                  <div className='checkbox__wrapper'>
                                    <Tooltip tooltip='Make sure to apply the correct pricing (Fee/Credits) as mentioned in the applicable Contract for this account.' />
                                  </div>
                                </FlexRow>
                              </FlexItem>
                            </FlexRow>
                          </RenderEplRow>
                          <RenderEplRow label='Pricing'>
                            <FlexRow itemSpacing='md'>
                              <FlexItem>
                                <Field
                                  name='pricingId'
                                  itemToString={item => item && item.name}
                                  options={staticData.pricings}
                                  component={Dropdown}
                                />
                              </FlexItem>
                              <FlexItem>
                                <div className='checkbox__wrapper'>
                                  <Tooltip tooltip='The pricing unit you select here will be visible for the Client on the Client Interface for this EPL.' />
                                </div>
                              </FlexItem>
                            </FlexRow>
                          </RenderEplRow>
                          <EPLAutosave
                            eplId={epl.id}
                            values={form.values}
                            eplModel={eplModel}
                          />
                        </Form>
                        {this.renderRecommendedHonorarium()}
                        <div style={{ marginTop: 8, paddingLeft: 120 }}>
                          {this.renderMargin(margin)}
                        </div>
                        <RenderEplRow label='Delivered by' topMargin='m-t-md'>
                          <FlexRow itemSpacing='md'>
                            <FlexItem>
                              <ACL
                                roles={['Admin', 'ProjectManagement']}
                                alternative={
                                  <span className='shift-down'>
                                    {epl.employees[0]
                                      ? epl.employees[0].fullName
                                      : '-'}
                                  </span>
                                }
                              >
                                <Autocomplete
                                  value={epl.employees[0]}
                                  itemToString={item => item && item.fullName}
                                  loadOptions={eplModel.handleAutocomplete}
                                  onChange={this.handleDeliveredByChange}
                                />
                              </ACL>
                            </FlexItem>

                            <FlexItem>
                              <div className='checkbox__wrapper'>
                                <Tooltip
                                  tooltip={
                                    <TeamInfoTooltip
                                      teamInfo={eplModel.details.teamInfo}
                                    />
                                  }
                                />
                              </div>
                            </FlexItem>
                          </FlexRow>
                        </RenderEplRow>
                      </div>
                    </div>
                    <Attachment
                      label='Attachments'
                      url={`/api/expert-project-link/${epl.id}/attachments`}
                      onOk={eplModel.getDetails}
                      onDelete={fileId =>
                        confirmDelete(fileId, fileApi.deleteFile).then(
                          eplModel.getDetails
                        )
                      }
                      attachments={details.attachments}
                    />
                  </div>
                  <div style={{ marginLeft: 35, flexGrow: 1, minWidth: 100 }}>
                    <div className='epl-tabs'>
                      <h4 className={!honorariumTabActive ? 'tab active' : 'tab'}
                        onClick={() => this.showHonorariumTab(false)}
                        style={{ display: 'inline-block' }}>Operational Guidelines</h4>
                      <h4 className={honorariumTabActive ? 'tab active' : 'tab'}
                        onClick={() => this.showHonorariumTab(true)}
                        style={{ display: 'inline-block' }}>Honorarium History</h4>
                    </div>
                    <div
                      style={{
                        maxHeight: 420,
                        overflowY: 'auto',
                        overflowX: 'auto'
                      }}
                    >
                      {!honorariumTabActive && <div style={{ marginTop: 12 }}
                        dangerouslySetInnerHTML={{
                          __html:
                            eplModel.details.project.parentAccount
                              .operationalGuidelines
                        }}
                      />}
                      {honorariumTabActive && <div className='honorarium-history'>
                        {loading && <Spinner />}
                        {!loading && !paidProjects.length && <div style={{ marginTop: 30 }}>No honorarium history...</div>}
                        {!loading && !!paidProjects.length && <div>
                          <MaUTable>
                            <TableHead>
                              <TableRow>
                                <TableCell>Project Name</TableCell>
                                <TableCell>Interview Date</TableCell>
                                <TableCell>Honorarium</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {paidProjects.map((row, i) => {
                                const duration = row.consultationDuration
                                const fee = row.feeItems[0].value
                                const feeCurrencyId = row.feeItems[0].currencyId
                                const hourlyFee = (fee / duration) * 60
                                return (
                                  <TableRow key={row.id}
                                    className='clickable-row'
                                    onClick={e => this.showProjectDetails(e, row.projectId)}>
                                    <TableCell>
                                      <span onClick={e => e.stopPropagation()}>
                                        <Link to={`/project/${row.projectId}/experts-pipeline/${row.expertProjectLink.id}`}>
                                          {row.project.projectName}
                                        </Link>
                                      </span>
                                      <div className='desc desc--top-spacing'>
                                        {formatDate(row.project.startDate)} -{' '}
                                        {row.project.endDate
                                          ? formatDate(row.project.endDate)
                                          : 'Current'}
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      {row.expertProjectLink.dateInterviewed && formatDate(row.expertProjectLink.dateInterviewed, 'DD/MM/YYYY')}
                                    </TableCell>
                                    <TableCell>
                                      {this.renderCurrency(hourlyFee, feeCurrencyId, 'currencies') || '-'}
                                    </TableCell>
                                  </TableRow>
                                )
                              })}
                            </TableBody>
                          </MaUTable>
                          <Pagination
                            total={this.projects.count}
                            perPage={5}
                            page={this.page}
                            onChange={p => this.changePage(p)}
                          />
                        </div>}
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            )}
          />
          <div className='block epl-actions'>
            <Link to={expertProfileLink}>
              <div className='icon-label'>
                <FullProfileIcon />
                <span>Full profile</span>
              </div>
            </Link>
            {this.renderExportButton()}
            <div className='icon-label' onClick={this.handleDeleteEpl}>
              <DeleteIcon />
              <span>Delete from pipeline</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default inject('growlStore', 'eplStore', 'segmentStore', 'staticData', 'sidebarStore', 'projectStore')(
  observer(EPLExpand)
)

const RenderEplRow = ({ label, topMargin, children, onClick }) => {
  return (
    <div className={`actions__single ${topMargin || ''}`} onClick={onClick}>
      <span className='actions__single__label'>{label}</span>
      <div>{children}</div>
    </div>
  )
}

RenderEplRow.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  topMargin: PropTypes.string,
  children: PropTypes.object,
  onClick: PropTypes.func
}

function initializeForm(epl) {
  return pick(toJS(epl), [
    'eplStatusCommentId',
    'segmentId',
    'honorariumCurrencyId',
    'honorarium',
    'free',
    'feeCurrencyId',
    'fee',
    'credits',
    'pricingId'
  ])
}
